import React from 'react'
import Products from 'pages/products'
import Variations from 'pages/variations'
import { Redirect, Route, Switch } from 'react-router-dom'
import 'assets/scss/theme.scss'

function App() {
  return (
    <div className="App">
      <Switch>
        <Route path="/" exact>
          <Redirect to="/products" />
        </Route>
        <Route path="/products" exact>
          <Products />
        </Route>
        <Route path="/products/:productId/variation">
          <Variations />
        </Route>
      </Switch>
    </div>
  )
}

export default App
